<template>
  <div id="app" class="mm-container">
    <!-- <Header></Header> -->
    <div class="r-container">
      <router-view />
    </div>
    <div class="footer-container">
      <Footer :list="list" @choose="handleChoose"></Footer>
    </div>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
import { list } from "@/utils/index";

export default {
  name: "App",
  data() {
    return {
      list: list
    };
  },
  created() {
    if (sessionStorage.getItem("routerName")) {
      this.$store.dispatch("SetRouter", sessionStorage.getItem("routerName"));
      this.$store.dispatch("SetMenuName", sessionStorage.getItem("menuName"));
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("routerName", this.$store.state.app.routerName);
      sessionStorage.setItem("menuName", this.$store.state.app.menuName);
    });
  },
  methods: {
    handleChoose(e) {
      this.$router.push({
        path: "/product",
        query: { index: e }
      });
      this.$store.commit("setProductIndex", e);
    }
  }
};
</script>

<style>
.r-container {
  /* padding-bottom: 300px; */
}
.mm-container {
  position: relative;
  /* height: 100%; */
}
.footer-container {
  max-width: 1400px;
  margin: 0 auto;
}
* {
  font-family: "Microsoft YaHei", microsoft yahei ui, 微软雅黑, PingFang SC,
    "PingFangSC-Medium", PingFangSC-Regular;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: "iconfont"; /* Project id 2185250 */
  src: url("//at.alicdn.com/t/font_2185250_c5e4pt53bj.woff2?t=1629267761659")
      format("woff2"),
    url("//at.alicdn.com/t/font_2185250_c5e4pt53bj.woff?t=1629267761659")
      format("woff"),
    url("//at.alicdn.com/t/font_2185250_c5e4pt53bj.ttf?t=1629267761659")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 28px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue